import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {NgForm} from "@angular/forms";
import {ChroniePaymentListTypes} from "../../../shared/interface/chronie";
import {ReplaySubject} from "rxjs";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {select, Store} from "@ngrx/store";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {ChronieService} from "../../../shared/services/chronie.service";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {FilterService} from "../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {HiperioConfigDirectService} from "../../../shared/services/hiperio-config-direct.service";
import {HiperioConfigDirect} from "../../../shared/interface/hiperio-config-direct";

@Component({
  selector: 'app-hiperio-config-direct-list',
  templateUrl: './hiperio-config-direct-list.component.html',
  styleUrls: ['./hiperio-config-direct-list.component.scss']
})
export class HiperioConfigDirectListComponent implements AfterViewInit, OnInit, OnDestroy {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;

  initialFilters: any;
  list: HiperioConfigDirect[] = [];
  displayedColumns: string[] = [
    'tu', 'name', 'value', 'ofwca'
  ];
  totalData = 0;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private hiperioConfigDirectService: HiperioConfigDirectService,
    private auth: AuthService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private store: Store<StoreRootState>,
    private filterService: FilterService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.hiperioConfigDirectService.hiperioConfigDirectListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<HiperioConfigDirect>) => {
          this.list = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  ngOnInit(): void {
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
    }, filters);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  buildFilters(): any {
    return {...this.initialFilters};
  }

  loadListData(): void {
    this.hiperioConfigDirectService.getLst(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters()
    );
  }

}
